import { type MutableRefObject, useEffect } from 'react'

function useResizeObserver(
	ref: MutableRefObject<null>,
	setWidth: (w: number) => void,
	setHeight: (h: number) => void = () => {},
) {
	useEffect(() => {
		// Ensure the ref.current is not null
		if (ref.current) {
			const resizeObserver = new ResizeObserver(entries => {
				setWidth(entries[0].contentBoxSize[0].inlineSize)
				setHeight(entries[0].contentBoxSize[0].blockSize)
			})

			// Start observing the target element
			resizeObserver.observe(ref.current)

			// Cleanup function to disconnect the ResizeObserver
			return () => resizeObserver.disconnect()
		}
	}, [ref, setWidth, setHeight]) // Include setWidth and setHeight in the dependency array to handle changes in these functions
}

export default useResizeObserver
